export default "__VITE_ASSET__BL8Ot8zm__"